import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { SectionHead } from "./SectionHead";

const EMPTY = { full_name: "", email: "", company: "", role: "", consent: false, website: "" };

export const Invite = () => {
  const [form, setForm] = useState(EMPTY);
  const [st, setSt] = useState({ busy: false, ok: "", err: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent) return setSt({ busy: false, ok: "", err: "Please confirm that we may contact you about the summit." });
    setSt({ busy: true, ok: "", err: "" });
    try {
      const r = await api.post("/early-access", form);
      setSt({ busy: false, ok: r.data.message, err: "" });
    } catch (x) {
      setSt({ busy: false, ok: "", err: formatApiError(x.response?.data?.detail) });
    }
  };
  return (
    <section className="ns-sec ns-invite" id="invite" data-testid="ns-invite">
      <img className="ns-photo" src="/images/vision-hall-audience.webp" alt="" loading="lazy" />
      <div className="ns-shade" aria-hidden />
      <div className="ns-wrap">
        <SectionHead nr="08" label="Request an invitation" right="Private & invitation-led" />
        <div className="ns-grid">
          <div className="g-1-5">
            <h2 className="ns-h2" data-rv data-testid="ns-invite-h">Request an invitation.</h2>
            <p className="ns-lede mt" data-rv style={{ "--d": ".1s" }} data-testid="ns-invite-lede">700 seats, one at a time. Tell us who you are — we review every request and reply personally.</p>
          </div>
          <div className="g-7-12" data-rv style={{ "--d": ".2s" }}>
            {st.ok ? (
              <div className="ns-ok" data-testid="ns-invite-ok">
                <h3 className="ns-h3">Thank you, {form.full_name.split(" ")[0] || "there"}.</h3>
                <p className="ns-p">Your request is registered. We review every request and reply personally — you will hear from us before invitations go out.</p>
              </div>
            ) : (
              <form className="ns-form" onSubmit={submit} noValidate data-testid="ns-invite-form">
                <div className="ns-field"><label htmlFor="in">Full name</label><input id="in" value={form.full_name} onChange={set("full_name")} required autoComplete="name" data-testid="ns-invite-name" /></div>
                <div className="ns-field"><label htmlFor="ie">Work email</label><input id="ie" type="email" value={form.email} onChange={set("email")} required autoComplete="email" data-testid="ns-invite-email" /></div>
                <div className="ns-field"><label htmlFor="ic">Company</label><input id="ic" value={form.company} onChange={set("company")} required autoComplete="organization" data-testid="ns-invite-company" /></div>
                <div className="ns-field"><label htmlFor="ir">Role</label><input id="ir" value={form.role} onChange={set("role")} required autoComplete="organization-title" data-testid="ns-invite-role" /></div>
                <input className="ns-hp" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} aria-hidden />
                <label className="ns-check">
                  <input type="checkbox" checked={form.consent} onChange={set("consent")} data-testid="ns-invite-consent" />
                  <span>I agree that Norwegian AI Summit may contact me about the summit. No newsletters, no third parties.</span>
                </label>
                <div className="ns-form-foot">
                  <button className="ns-btn" type="submit" disabled={st.busy} data-testid="ns-invite-submit">{st.busy ? "Sending …" : "Request an invitation"}<span className="ar">→</span></button>
                  {st.err && <p className="ns-msg err" data-testid="ns-invite-err">{st.err}</p>}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
